import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/case-studies";
import { caseStudiesJsonLd, caseStudiesItemListJsonLd } from "@/pages/case-studies.seo";

import { brand } from "@/config/brand";
const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;
const OG_ALT = "Digitally Baffled LTD — UK Digital Transformation Consultancy";

export const Route = createFileRoute("/case-studies")({
  head: () => ({
    meta: [
      { title: "Case Studies — Real Client Results | Digitally Baffled" },
      {
        name: "description",
        content:
          "See how Digitally Baffled helped Eclipse Paving generate £70,000+ in work through Google Ads, web design, SEO & GEO, and Google Business Profile. Real results for UK businesses.",
      },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "Case Studies — £70,000+ Generated for Eclipse Paving | Digitally Baffled" },
      {
        property: "og:description",
        content:
          "Eclipse Paving went from zero online presence to £70,000+ in work generated through Google Ads, web design, and SEO managed by Digitally Baffled LTD.",
      },
      { property: "og:url", content: `${SITE_URL}/case-studies` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:secure_url", content: OG_IMAGE },
      { property: "og:image:type", content: "image/png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: OG_ALT },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:site", content: "@digitallybaffld" },
      { name: "twitter:creator", content: "@digitallybaffld" },
      { name: "twitter:title", content: "Case Studies — Real Results for Real Businesses | Digitally Baffled" },
      {
        name: "twitter:description",
        content:
          "Real results for real businesses. See how Digitally Baffled has helped UK small businesses grow their digital presence and generate revenue.",
      },
      { name: "twitter:image", content: OG_IMAGE },
      { name: "twitter:image:alt", content: OG_ALT },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/case-studies` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(caseStudiesJsonLd) },
      { type: "application/ld+json", children: JSON.stringify(caseStudiesItemListJsonLd) },
    ],
  }),
  component: Page,
});
